import { createFileRoute } from "@tanstack/react-router";
import { FilialEditarPage } from "@/paginas/pg_empresa/empresa-filiais-editar";

export const Route = createFileRoute("/_authenticated/empresa-filiais-editar")({
  validateSearch: (busca: Record<string, unknown>) => ({
    id: typeof busca["id"] === "string" ? (busca["id"] as string) : "",
  }),
  head: () => ({
    meta: [
      { title: "Editar filial — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Cadastro completo da filial: endereço, contatos, redes sociais e localização no mapa.",
      },
      { property: "og:title", content: "Editar filial — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Cadastro completo da filial: endereço, contatos, redes sociais e localização no mapa.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: FilialEditarPage,
});
